import Head from 'next/head';
import { NextSeo } from 'next-seo';
import FreeReferral from '@cont/Settings/Referral/ReferralDetails/FreeReferral';
import { simpleFetch as fetcher } from '@api/fetchers';
import Layout from '@layout/FreeLayout/FreeLayout';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import { getDefaultHost } from '@utils/api-helper/host';
import {
  getFreeReferralFeedEndpoint,
  getRewardDetailsEndpoint
} from '@cont/Settings/Referral/ReferralDetails/apiHelper';

const DefaultHost = getDefaultHost();

const ReferralPage = ({ feedData, rewardDetails }) => {
  const title = 'Referral | Unacademy';

  return (
    <>
      <NextSeo
        title={title}
        openGraph={{
          title
        }}
      />
      <Head>
        <title>Referral | Unacademy</title>
      </Head>
      <FreeReferral feedData={feedData} rewardDetails={rewardDetails} />
    </>
  );
};

ReferralPage.pageInfo = {
  name: 'Referral Homepage',
  isMWebSupported: true,
  layoutOptions: {
    hideSearch: true,
    hideIntercom: true
  }
};

export const getStaticProps = async () => {
  const promises = [];
  promises.push(fetcher(`${DefaultHost}${getFreeReferralFeedEndpoint()}`));
  promises.push(fetcher(`${DefaultHost}${getRewardDetailsEndpoint()}`));

  try {
    const [feedData, rewardDetails] = await Promise.all(promises);
    return {
      props: {
        feedData: feedData?.results,
        rewardDetails
      }
    };
  } catch (error) {
    return { notFound: true, revalidate: 60 };
  }
};

export default ReferralPage;

ReferralPage.Layout = Layout;
ReferralPage.Wrapper = PageReduxProvider;
